import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, UserActions, UserMutations } from './types';
import { LookupActions, LookupMutations } from '@/shared/store/lookup/types';
import UserService from '@/shared/services/UserService';

const _actions = namespaceHelper.removeNamespace(namespace, UserActions);
const _mutations = namespaceHelper.removeNamespace(namespace, UserMutations);

export default {
  async [_actions.CLEAR_NAVIGATION]({ commit }) {
    commit(_mutations.SET_AUTHENTICATION_REDIRECT, null);
  },
  async [_actions.FETCH_USER_PROFILE]({ commit }) {
    commit(_mutations.SET_LOADING, true);
    try {
      var userProfileResult = await UserService.getUserProfile();
      commit(_mutations.SET_PROFILE, userProfileResult.data);
    } catch {
      // TODO: Should this be null or empty object?
      commit(_mutations.SET_PROFILE, {});
    } finally {
      commit(_mutations.SET_LOADING, false);
    }
  },
  // use this after msal login events
  async [_actions.AFTER_LOGIN]({ commit, dispatch }, maslAccount) {
    commit(_mutations.SET_MSAL_ACCOUNT, maslAccount);
    await dispatch(UserActions.FETCH_USER_PROFILE, null, { root: true });
    await dispatch(LookupActions.FETCH_LOOKUPS, null, { root: true });
  },
  // Vams has custom login using vams api
  async [_actions.LOGIN]({ commit }, userCredentials) {
    let loginResult = await UserService.login(userCredentials);
    commit(_mutations.SET_LOGGED_IN, loginResult.data);
  },
  async [_actions.LOGOUT]({ commit }, vamsLogout = true) {
    sessionStorage.clear();
    if (vamsLogout) await UserService.logout();
    commit(_mutations.SET_LOGGED_OUT);
    commit(_mutations.SET_PROFILE, {});
    commit(LookupMutations.RESET_LOOKUPS, null, { root: true });
  },
  [_actions.SET_AUTHENTICATION_REDIRECT]({ commit }, redirect) {
    commit(_mutations.SET_AUTHENTICATION_REDIRECT, redirect);
  }
};
